var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.3,
    height: 21.3,
    viewBox: "0 0 18.3 21.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-education{stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.35 -2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-education",
    d: "M21.75,30h-1.5V27.75A3.755,3.755,0,0,0,16.5,24H12a3.755,3.755,0,0,0-3.75,3.75V30H6.75V27.75A5.256,5.256,0,0,1,12,22.5h4.5a5.256,5.256,0,0,1,5.25,5.25Z",
    transform: "translate(-0.75 -6.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-education",
    d: "M5.25,6.75a.75.75,0,0,0-.75.75v6.75H6V7.5A.75.75,0,0,0,5.25,6.75Z",
    transform: "translate(0 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-education",
    d: "M4.5,2.25v1.5H8.25V9a5.25,5.25,0,0,0,10.5,0V3.75H22.5V2.25Zm5.25,1.5h7.5V6H9.75Zm3.75,9A3.75,3.75,0,0,1,9.75,9V7.5h7.5V9A3.75,3.75,0,0,1,13.5,12.75Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.f2ecf9b8.svg";
export { ForwardRef as ReactComponent };